import { getRef, invalidateRef } from './refDataCache'

// The whole MEWS company list, cached for the session (10 min TTL).
//
// MEWS's company Names filter is exact-match, so company search is done
// client-side over the full list. contacts.vue fetched that full list from
// MEWS on every search and every tab switch; it now reads it from here.
// Concurrent callers share one request; a failure is not cached.

const KEY = 'mews:companies:all'
const TTL_MS = 10 * 60 * 1000

type CompaniesApi = { companies: { getAll: () => Promise<any[]> } }

export function getAllMewsCompaniesCached(api: CompaniesApi): Promise<any[]> {
  return getRef(KEY, () => api.companies.getAll(), TTL_MS)
}

export function invalidateMewsCompanies(): void {
  invalidateRef(KEY)
}

export function filterMewsCompanies(all: readonly any[] | null | undefined, query: string): any[] {
  const lq = query.trim().toLowerCase()
  return (all || []).filter((c: any) =>
    (c?.Name || '').toLowerCase().includes(lq)
    || (c?.ContactPerson || '').toLowerCase().includes(lq)
    || (c?.Contact || '').toLowerCase().includes(lq))
}
